<template>
  <div class="analysis">
    <div class="header">
      <div class="title">数据中心</div>
      <!-- <div class="button">实训任务</div> -->
    </div>
    <div class="container">
      <div class="home-container">
        <!-- <iframe class="iframe" :src="iframeSrc" frameborder="0"></iframe> -->
         <router-view class="iframe"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Analysis",
  data() {
    return {
      // iframeSrc: `${window.location.origin}/#/training/accountDataCenter`,
    };
  },
  created() {},
  computed: {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.analysis {
  width: 100%;
  height: 100%;
  background: #fff;
  .header {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    box-sizing: border-box;
    border-bottom: 1px solid #eeeeee;
    .title {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333;
      line-height: 19px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .button {
      width: 88px;
      height: 36px;
      background: #006eff;
      border-radius: 4px 4px 4px 4px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .container {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 50px;
    box-sizing: border-box;
    .home-container {
      position: relative;
      width: 420px;
      height: 740px;
      background-image: url("../../assets/img/image/phone-dc9743aa.png");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
     
      .iframe {
        width: 340px;
        height: 630px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        overflow: hidden;
      }
    }
  }
}
</style>
